import service from '@/store/services/vendors/labourer-educations-service';

const state = {
    list: {},
    labourerEducation: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerEducation) => {
        state.labourerEducation = labourerEducation;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourerEducation => {
                commit('SET_RESOURCE', labourerEducation);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourerEducation => {
                commit('SET_RESOURCE', labourerEducation);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourerEducation) => {
                commit('SET_RESOURCE', labourerEducation);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourerEducation) => {
                commit('SET_RESOURCE', labourerEducation);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    labourerEducation: state => state.labourerEducation,
    dropdown: (state) => {
        return state.list.map(labourerEducation => ({
            id: labourerEducation.id,
        }));
    }
};

const labourerEducations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerEducations;
